import { render, staticRenderFns } from "./OnlCgformAutoModal.vue?vue&type=template&id=6ab0dd79&scoped=true&"
import script from "./OnlCgformAutoModal.vue?vue&type=script&lang=js&"
export * from "./OnlCgformAutoModal.vue?vue&type=script&lang=js&"
import style0 from "./OnlCgformAutoModal.vue?vue&type=style&index=0&id=6ab0dd79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab0dd79",
  null
  
)

export default component.exports